import styled from "@emotion/styled"
import { NewText } from "ui"
import { sharedColors } from "ui/theme/colors"

const StyledTable = styled.div`
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 480px;
    border: 1px solid #6f6f6f;
    padding: 24px;
  }
`

const StyledItemDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
`

const StyledDot = styled.div<{ $background: string }>`
  min-width: 13px !important;
  min-height: 13px !important;
  background-color: ${(p) => p.$background};
  border-radius: 50%;
  margin-right: 8px;
`

type Props = {
  stockHolderData: any
}

const colors = [
  "#0E4D81",
  "#1679CA",
  "#1988E2",
  "#C8E8FF",
  "#B6D9F7",
  "#238EE7",
  "#5AAFED",
  "#B6D9F7",
]

function ShareHolderTable({ stockHolderData }: Props) {
  return (
    <StyledTable>
      {stockHolderData?.stockHolders
        .sort((a: any, b: any) => b.capital - a.capital)
        .map((item: any, index: any) => (
          <StyledItemDiv key={index}>
            <StyledWrapper>
              <StyledDot $background={colors[index]} />
              <NewText
                component={"p"}
                desktopFontSize={18}
                desktopLineHeight={"26px"}
                desktopFontWeight={400}
                mobileFontSize={16}
                mobileLineHeight={"23px"}
                color={sharedColors.black}
              >
                {item.shareHolderName}
              </NewText>
            </StyledWrapper>
            <NewText
              component={"p"}
              desktopFontSize={18}
              desktopLineHeight={"26px"}
              desktopFontWeight={400}
              mobileFontSize={16}
              mobileLineHeight={"23px"}
              color={sharedColors.black}
            >
              {item.capital}%
            </NewText>
          </StyledItemDiv>
        ))}
    </StyledTable>
  )
}

export default ShareHolderTable
